export default class Collection {

    addMany (arrayToAdd) {
        arrayToAdd.forEach((argument) => {
            this.add(...argument);
        });
    }

}



/** WEBPACK FOOTER **
 ** ./tables/util/Collection.js
 **/